import {useState} from 'react';
import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {DhcpServer} from '../../Types/routerForms';
import {useUpdateDhcp} from '../../Hooks/RouterManager';
import EditDhcpModal from './EditDhcpModal';
import ActionIcon from '../../../../Components/ActionIcon';
import Level3Title from '../../../../app/common/components/title/Level3Title';

interface DhcpServerSectionProps {
  routerId: string;
  server: DhcpServer | null;
  networks: string[];
}

const DhcpServerSection = ({routerId, server, networks}: DhcpServerSectionProps): JSX.Element => {
  const intl = useIntl();
  const [showEdit, setShowEdit] = useState(false);
  const updateDhcp = useUpdateDhcp(routerId);

  const handleSave = (next: DhcpServer) =>
    updateDhcp.mutate({
      id: next.id,
      network: next.network,
      rangeStart: next.rangeStart,
      rangeEnd: next.rangeEnd,
      wins: next.wins || null,
      active: next.active,
    });

  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title>
          <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.DHCP.TITLE'})} />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        {server === null ? (
          <p className="text-muted mb-0">
            {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.DHCP.EMPTY'})}
          </p>
        ) : (
          <>
            <table className="table table-row-dashed align-middle">
              <thead>
                <tr className="fw-semibold text-muted">
                  <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.DHCP.RANGE_START'})}</th>
                  <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.DHCP.RANGE_END'})}</th>
                  <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.DHCP.WINS'})}</th>
                  <th>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.LAN.DHCP.ACTIVE'})}</th>
                  <th style={{width: 60}}></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{server.rangeStart}</td>
                  <td>{server.rangeEnd}</td>
                  <td>{server.wins || <span className="text-muted">—</span>}</td>
                  <td>
                    <span className={`badge bg-${server.active ? 'success' : 'secondary'}`}>
                      {intl.formatMessage({
                        id: server.active ? 'COMMON.YES' : 'COMMON.NO',
                      })}
                    </span>
                  </td>
                  <td>
                    <ActionIcon
                      label={intl.formatMessage({id: 'COMMON.EDIT'})}
                      faIcon="fa-solid fa-pen-to-square text-primary"
                      onClick={() => setShowEdit(true)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <EditDhcpModal
              show={showEdit}
              onHide={() => setShowEdit(false)}
              initial={server}
              networks={networks}
              onSave={handleSave}
            />
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default DhcpServerSection;
